import {pageInfo,updateFreuency} from '../api';
import {plant} from '../../../../../api'
import {Message} from 'element-ui';

const toxinExemptFreuency = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    updateFreuencyObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    UPDATE_FREUENCY(state, data){
      state.updateFreuencyObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async updateFreuency({commit}, obj){
      let resp = await updateFreuency(obj);
      commit('UPDATE_FREUENCY', resp);
    }
  }
}
export default toxinExemptFreuency



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/toxinExemptFreuency/store/toxinExemptFreuency.store.js